import React from 'react';
import { Icon } from './Icon';

interface ITrafficLightProps {
  direction: 1 | -1 | 0;
  isNeg?: boolean;
  lowerCutoff: number;
  upperCutoff: number;
  value: number;
  useAbsoluteValueInCutoff?: boolean;
}

const getColor = (
  value: number,
  lowerCutoff: number,
  upperCutoff: number,
  direction: 1 | -1 | 0,
  isNeg: boolean
): string => {
  const green = 'var(--color-material-500-green)';
  const red = 'var(--color-material-500-red)';
  const yellow = 'var(--color-material-500-yellow)';

  if (isNaN(value)) {
    return 'transparent';
  }

  const comparisonValue = isNeg ? -value : value;

  if (direction === 0) {
    if (-value >= upperCutoff) return green;
    if (-value <= lowerCutoff) return red;
    return yellow;
  }

  if (direction === 1) {
    if (comparisonValue >= upperCutoff) return green;
    if (comparisonValue < lowerCutoff) return red;
    return yellow;
  }

  // direction === -1
  if (comparisonValue <= lowerCutoff) return green;
  if (comparisonValue >= upperCutoff) return red;
  return yellow;
};

export const TrafficLight: React.FC<ITrafficLightProps> = (
  props: ITrafficLightProps
): React.ReactElement => {
  const value = props.useAbsoluteValueInCutoff
    ? Math.abs(props.value)
    : props.value;

  const color = getColor(
    value,
    props.lowerCutoff,
    props.upperCutoff,
    props.direction,
    props.isNeg ?? false
  );
  return (
    <div
      style={{
        height: '100%',
        width: '100%',
        backgroundColor: color,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '5px',
      }}
    >
      {isNaN(props.value) ? (
        '--'
      ) : props.value >= 0 ? (
        <Icon name='trending_up' color='var(--color-dark-text)' style={{ fontSize: '28px' }} />
      ) : (
        <Icon name='trending_down' color='var(--color-dark-text)' style={{ fontSize: '28px' }} />
      )}
    </div>
  );
};

